import { createSelector } from "reselect";
import { routePathnameSelector } from "src/selectors/router_selectors";

/**
 * Memoized selector, returns true if admission status filter is enabled, false otherwise
 */

export const admissionFilterEnabledSelector = createSelector(
  routePathnameSelector,
  pathname => {
    //following component is commented for now
    return pathname && pathname === "/admin/patients" ? true : false;
  }
);
